const getters = {
  HasTabbar: (state) => state.settings.HasTabbar,
  active: (state) => state.user.active,
  avatarurl: (state) => state.user.avatarurl,
  role: (state) => state.user.role,
  rolename: (state) => state.user.rolename,
  nickname: (state) => state.user.nickname,
  opPicUrl: (state) => state.user.opPicUrl,
  NoticeImg: (state) => state.settings.NoticeImg
}

export default getters
